<script lang="ts">
	import {
		Content as CarouselContent,
		Item as CarouselItem,
		Root as CarouselRoot
	} from '$lib/components/ui/carousel';
	import Autoscroll from 'embla-carousel-auto-scroll';
	import TestimonialCard from './_components/testimonial-card.svelte';
	import { Badge } from '$lib/components/ui/badge';
</script>

<div class="mx-auto my-24 flex h-auto w-full flex-col items-center justify-center gap-16">
	<div class="bg-grid-pattern mb-60 aspect-square max-h-[800px] max-w-[800px]" />
	<div
		class="mx-auto flex max-w-2xl flex-col items-center justify-center gap-3 lg:mx-0 lg:max-w-none"
	>
		<span class="text-center text-sm text-primary">Testimonials</span>
		<h2 class="text-center text-4xl sm:text-5xl">What our users say</h2>
		<p class="max-w-[480px] px-2 text-center font-light tracking-wider text-lightTertiary">
			During our testing phase we had over 2000+ happy users. This is what a handful of them said ✨
		</p>
	</div>
	<div class="flex w-full flex-col gap-3 overflow-hidden">
		<CarouselRoot
			opts={{
				loop: true,
				skipSnaps: true
			}}
			plugins={[Autoscroll({ stopOnInteraction: false, stopOnFocusIn: false, speed: 1.2 })]}
		>
			<CarouselContent class="-ml-3">
				<CarouselItem class="basis-1/2 pl-3 md:basis-1/3 lg:basis-1/5">
					<TestimonialCard text="Definitely has great potentional, keep up the good work" />
				</CarouselItem>
				<CarouselItem class="basis-1/2 pl-3 md:basis-1/3 lg:basis-1/5">
					<TestimonialCard
						text="truly great app, helped me understand game and matchups more so my winratio peaked this season"
					/>
				</CarouselItem>
				<CarouselItem class="basis-1/2 pl-3 md:basis-1/3 lg:basis-1/5">
					<TestimonialCard
						text="thank you for the amazing job, continue the good work, for now I cant tell you lot more to add, but when you launch your app, let me know"
					/>
				</CarouselItem>
				<CarouselItem class="basis-1/2 pl-3 md:basis-1/3 lg:basis-1/5">
					<TestimonialCard
						text="Thank You for teach me many things in lol, that's all. Enjoy further development and I'm waiting for updates"
					/>
				</CarouselItem>
				<CarouselItem class="basis-1/2 pl-3 md:basis-1/3 lg:basis-1/5">
					<TestimonialCard text="i love what you're doing! keep it up <3" />
				</CarouselItem>
				<CarouselItem class="basis-1/2 pl-3 md:basis-1/3 lg:basis-1/5">
					<TestimonialCard
						text="it seems like a really good ai from what I've seen so far, thanks for making it possible"
					/>
				</CarouselItem>
				<CarouselItem class="basis-1/2 pl-3 md:basis-1/3 lg:basis-1/5">
					<TestimonialCard
						text="Thank you guys for your work. I am looking forward to see this project be one time rly big. I think its such a powerfull technology and we should use it to get better at what we love to do :) Thank you so much <3"
					/>
				</CarouselItem>
				<CarouselItem class="basis-1/2 pl-3 md:basis-1/3 lg:basis-1/5">
					<TestimonialCard text="Thank you guys for this product" />
				</CarouselItem>
				<CarouselItem class="basis-1/2 pl-3 md:basis-1/3 lg:basis-1/5">
					<TestimonialCard text="Definitely has great potentional, keep up the good work" />
				</CarouselItem>
				<CarouselItem class="basis-1/2 pl-3 md:basis-1/3 lg:basis-1/5">
					<TestimonialCard
						text="truly great app, helped me understand game and matchups more so my winratio peaked this season"
					/>
				</CarouselItem>
				<CarouselItem class="basis-1/2 pl-3 md:basis-1/3 lg:basis-1/5">
					<TestimonialCard
						text="thank you for the amazing job, continue the good work, for now I cant tell you lot more to add, but when you launch your app, let me know"
					/>
				</CarouselItem>
				<CarouselItem class="basis-1/2 pl-3 md:basis-1/3 lg:basis-1/5">
					<TestimonialCard
						text="Thank You for teach me many things in lol, that's all. Enjoy further development and I'm waiting for updates"
					/>
				</CarouselItem>
				<CarouselItem class="basis-1/2 pl-3 md:basis-1/3 lg:basis-1/5">
					<TestimonialCard text="i love what you're doing! keep it up <3" />
				</CarouselItem>
				<CarouselItem class="basis-1/2 pl-3 md:basis-1/3 lg:basis-1/5">
					<TestimonialCard
						text="it seems like a really good ai from what I've seen so far, thanks for making it possible"
					/>
				</CarouselItem>
				<CarouselItem class="basis-1/2 pl-3 md:basis-1/3 lg:basis-1/5">
					<TestimonialCard
						text="Thank you guys for your work. I am looking forward to see this project be one time rly big. I think its such a powerfull technology and we should use it to get better at what we love to do :) Thank you so much <3"
					/>
				</CarouselItem>
				<CarouselItem class="basis-1/2 pl-3 md:basis-1/3 lg:basis-1/5">
					<TestimonialCard text="Thank you guys for this product" />
				</CarouselItem>
			</CarouselContent>
		</CarouselRoot>
	</div>
</div>
